/** Données assistant onboarding Hapivot (aligné sur htmls/hapivot_onboarding.html). */
import {
  MdAnalytics,
  MdCampaign,
  MdChat,
  MdFavorite,
  MdInventory2,
  MdMail,
  MdPhoneIphone,
  MdPsychology,
  MdSettings,
  MdShoppingCart,
  MdSignpost,
  MdSupportAgent,
} from "react-icons/md";

export const ACTIVITIES = [
  { id: "commandes", icon: <MdShoppingCart size={20} />, label: "Vente en ligne", sub: "Boutique, commandes, paiements", secteurs: ["ecomm", "retail"] },
  { id: "emailing", icon: <MdMail size={20} />, label: "Emailing marketing", sub: "Newsletters, promotions", secteurs: ["*"] },
  { id: "pub", icon: <MdCampaign size={20} />, label: "Publicité en ligne", sub: "Facebook Ads, Google Ads, TikTok", secteurs: ["*"] },
  { id: "analytics", icon: <MdAnalytics size={20} />, label: "Analyse d'audience", sub: "Google Analytics, Matomo…", secteurs: ["*"] },
  { id: "support", icon: <MdSupportAgent size={20} />, label: "Support client", sub: "Chat, ticketing, SAV", secteurs: ["*"] },
  { id: "crm", icon: <MdChat size={20} />, label: "CRM / Relation client", sub: "HubSpot, Salesforce, Pipedrive", secteurs: ["*"] },
  { id: "signature", icon: <MdSignpost size={20} />, label: "Signature électronique", sub: "Contrats, devis, CGV", secteurs: ["*"] },
  { id: "automation", icon: <MdSettings size={20} />, label: "Automatisation", sub: "Make, n8n, Zapier", secteurs: ["*"] },
  { id: "storage", icon: <MdInventory2 size={20} />, label: "Stockage documentaire", sub: "Google Drive, Notion, SharePoint", secteurs: ["*"] },
  { id: "social", icon: <MdPhoneIphone size={20} />, label: "Réseaux sociaux", sub: "Facebook, Instagram, LinkedIn…", secteurs: ["*"] },
  { id: "dons", icon: <MdFavorite size={20} />, label: "Collecte de dons", sub: "HelloAsso, Stripe, Donorbox", secteurs: ["asso"] },
  { id: "ia", icon: <MdPsychology size={20} />, label: "IA & automatisation texte", sub: "ChatGPT API, Claude, Mistral", secteurs: ["saas", "conseil", "marketing", "autre"] },
];

export const TOOLS = {
  commandes: { label: "Plateforme e-commerce", opts: ["Shopify", "WooCommerce", "PrestaShop", "Magento", "Autre"] },
  emailing: { label: "Outil d'emailing", opts: ["Mailchimp", "Brevo", "Klaviyo", "ActiveCampaign", "Mailjet", "Autre"] },
  pub: { label: "Régie(s) publicitaire(s)", opts: ["Meta Ads", "Google Ads", "TikTok Ads", "LinkedIn Ads", "Pinterest Ads", "Criteo", "Autre"], multi: true },
  analytics: { label: "Outil d'analytics", opts: ["Google Analytics 4", "Matomo", "Plausible", "Hotjar", "Autre"] },
  support: { label: "Outil de support", opts: ["Zendesk", "Crisp", "Intercom", "Freshdesk", "Gorgias", "Autre"] },
  crm: { label: "CRM", opts: ["HubSpot", "Salesforce", "Pipedrive", "Zoho CRM", "Brevo CRM", "Autre"] },
  signature: { label: "Signature électronique", opts: ["Yousign", "DocuSign", "Adobe Sign", "HelloSign", "Autre"] },
  automation: { label: "Outil d'automatisation", opts: ["Make (Integromat)", "n8n", "Zapier", "Power Automate", "Autre"] },
  storage: { label: "Stockage documentaire", opts: ["Google Drive", "Microsoft SharePoint", "Notion", "Dropbox", "OneDrive", "Autre"] },
  social: { label: "Réseau(x) social(aux)", opts: ["Facebook / Instagram", "LinkedIn", "TikTok", "YouTube", "X (Twitter)", "Pinterest", "Autre"], multi: true },
  dons: { label: "Plateforme de dons", opts: ["HelloAsso", "Stripe", "Donorbox", "PayPlug", "Leetchi", "Autre"] },
  ia: { label: "API IA utilisée", opts: ["OpenAI (ChatGPT)", "Anthropic (Claude)", "Mistral AI", "Google Gemini", "Autre"] },
};

export const TRAITEMENTS = {
  commandes: { nom: "Gestion des commandes", base: "Exécution du contrat", rc: false },
  emailing: { nom: "Emailing marketing", base: "Consentement", rc: false },
  pub: { nom: "Publicité ciblée et retargeting", base: "Consentement", rc: true },
  analytics: { nom: "Mesure d'audience", base: "Consentement", rc: true },
  support: { nom: "Gestion du support client", base: "Exécution du contrat", rc: false },
  crm: { nom: "Gestion de la relation client", base: "Intérêt légitime", rc: false },
  signature: { nom: "Signature électronique", base: "Exécution du contrat", rc: false },
  automation: { nom: "Automatisation des processus", base: "Intérêt légitime", rc: false },
  storage: { nom: "Gestion documentaire", base: "Exécution du contrat", rc: false },
  social: { nom: "Présence réseaux sociaux", base: "Consentement", rc: true },
  dons: { nom: "Collecte de dons", base: "Exécution du contrat", rc: false },
  ia: { nom: "Traitement IA", base: "Intérêt légitime", rc: false },
};

export const RC_TOOLS = [
  "Meta Ads",
  "Google Ads",
  "TikTok Ads",
  "LinkedIn Ads",
  "Pinterest Ads",
  "Criteo",
  "Google Analytics 4",
  "Facebook / Instagram",
  "TikTok",
  "YouTube",
  "X (Twitter)",
  "LinkedIn",
  "Pinterest",
];
